import React from "react";
import "./AchievementCard.scss";

export default function AchievementCard({cardInfo}) {
  function openUrlInNewTab(url, name) {
    if (!url) {
      console.log(`URL for ${name} not found`);
      return;
    }
    window.open(url, "_blank").focus();
  }

  return (
    <div className="certificate-card">
      <div className="certificate-image-div">
        <img
          src={cardInfo.image}
          alt={cardInfo.imageAlt || "Card Thumbnail"}
          className="card-image"
        />
      </div>
      <div className="certificate-detail-div">
        <h5 className="card-title">{cardInfo.title}</h5>
        <p className="card-subtitle">{cardInfo.description}</p>
      </div>
      <div className="certificate-card-footer">
        {cardInfo.footer.map((v, i) => (
          <span
            key={i}
            className="certificate-tag"
            onClick={() => openUrlInNewTab(v.url, v.name)}
          >
            {v.name}
          </span>
        ))}
      </div>
    </div>
  );
}
